<template>
  <svg
    :width="width || '122'"
    :height="height || '38'"
    viewBox="0 0 122 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M22.8144 18.4802L25.765 15.5387L16.2347 10.1989C15.6031 9.85872 15.0114 9.81097 14.4925 10.183L22.8144 18.4802ZM26.2679 21.924L29.3352 20.2041C29.9339 19.8698 30.2622 19.3963 30.2622 18.8711C30.2622 18.3469 29.9339 17.8724 29.3362 17.5381L26.5592 15.9834L23.433 19.0989L26.2679 21.924ZM13.9797 10.9062C13.9158 11.1021 13.8799 11.321 13.8799 11.5607V26.1884C13.8799 26.5674 13.9637 26.8937 14.1154 27.1533L22.1947 19.0979L13.9797 10.9062ZM22.8144 19.7146L14.7799 27.7253C14.9336 27.784 15.0992 27.8148 15.2738 27.8148C15.5852 27.8148 15.9095 27.7233 16.2397 27.5403L25.4746 22.3706L22.8144 19.7146Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M41.6807 13.0994H43.065C44.5597 13.0994 45.552 12.2419 45.552 10.9371C45.552 9.63238 44.5597 8.78093 43.065 8.78093H41.6807V13.0994ZM42.2381 12.6094V9.27098H43.065C44.2166 9.27098 45.0007 9.90803 45.0007 10.9371C45.0007 11.9723 44.2228 12.6094 43.065 12.6094H42.2381Z"
      fill="currentColor"
    />
    <path
      d="M47.9329 13.2219C48.9007 13.2219 49.5929 12.5298 49.5929 11.5497C49.5929 10.5757 48.9007 9.88353 47.9329 9.88353C46.9589 9.88353 46.2729 10.5757 46.2729 11.5497C46.2729 12.5298 46.9589 13.2219 47.9329 13.2219ZM47.9329 12.7625C47.2591 12.7625 46.7813 12.2541 46.7813 11.5497C46.7813 10.8514 47.2591 10.3429 47.9329 10.3429C48.6006 10.3429 49.0845 10.8514 49.0845 11.5497C49.0845 12.2541 48.6006 12.7625 47.9329 12.7625Z"
      fill="currentColor"
    />
    <path
      d="M51.1609 13.0994H51.8838L52.5331 10.5941H52.5943L53.2375 13.0994H53.9664L55.0017 10.006H54.4994L53.654 12.6033H53.5989L52.8883 10.006H52.239L51.5469 12.5971H51.4917L50.628 10.006H50.1257L51.1609 13.0994Z"
      fill="currentColor"
    />
    <path
      d="M55.7014 13.0994H56.2098V11.2924C56.2098 10.7534 56.6569 10.3491 57.1776 10.3491C57.7105 10.3491 58.0229 10.7289 58.0229 11.2495V13.0994H58.5314V11.2495C58.5314 10.4655 58.0291 9.88965 57.245 9.88965C56.8346 9.88965 56.4916 10.0857 56.271 10.4287H56.2098V10.006H55.7014V13.0994Z"
      fill="currentColor"
    />
    <path
      d="M59.5044 13.0994H60.0128V8.59717H59.5044V13.0994Z"
      fill="currentColor"
    />
    <path
      d="M62.5409 13.2219C63.5088 13.2219 64.2009 12.5298 64.2009 11.5497C64.2009 10.5757 63.5088 9.88353 62.5409 9.88353C61.567 9.88353 60.8809 10.5757 60.8809 11.5497C60.8809 12.5298 61.567 13.2219 62.5409 13.2219ZM62.5409 12.7625C61.8671 12.7625 61.3893 12.2541 61.3893 11.5497C61.3893 10.8514 61.8671 10.3429 62.5409 10.3429C63.2086 10.3429 63.6925 10.8514 63.6925 11.5497C63.6925 12.2541 63.2086 12.7625 62.5409 12.7625Z"
      fill="currentColor"
    />
    <path
      d="M65.9344 13.1974C66.4305 13.1974 66.792 13.0014 67.0125 12.6461H67.0676V13.0994H67.576V11.0474C67.576 10.3429 67.0676 9.88965 66.2652 9.88965C65.4872 9.88965 64.9788 10.3062 64.9788 10.9616H65.4933C65.4872 10.5757 65.7935 10.3491 66.259 10.3491C66.7675 10.3491 67.0676 10.6186 67.0676 11.0351V11.1576L66.21 11.2618C65.2912 11.3659 64.8257 11.7702 64.8257 12.3154C64.8257 12.8483 65.2667 13.1974 65.9344 13.1974ZM66.0079 12.7748C65.5914 12.7748 65.3341 12.5971 65.3341 12.3031C65.3341 12.0152 65.5791 11.7702 66.21 11.6906L67.0676 11.5926V11.8682C67.0676 12.3889 66.6388 12.7748 66.0079 12.7748Z"
      fill="currentColor"
    />
    <path
      d="M69.9963 13.2219C70.4986 13.2219 70.8968 13.0014 71.1234 12.6216H71.1847V13.0994H71.6931V8.59717H71.1847V10.4655H71.1234C70.8968 10.0918 70.4864 9.88353 69.9902 9.88353C69.0836 9.88353 68.3914 10.5818 68.3914 11.5497C68.3914 12.5175 69.0898 13.2219 69.9963 13.2219ZM70.0515 12.7625C69.3899 12.7625 68.8999 12.2419 68.8999 11.5497C68.8999 10.8697 69.3838 10.3429 70.0515 10.3429C70.713 10.3429 71.1969 10.8697 71.1969 11.5497C71.1969 12.2296 70.713 12.7625 70.0515 12.7625Z"
      fill="currentColor"
    />
    <path
      d="M75.8449 13.2219C76.8127 13.2219 77.5049 12.5298 77.5049 11.5497C77.5049 10.5757 76.8127 9.88353 75.8449 9.88353C74.8709 9.88353 74.1849 10.5757 74.1849 11.5497C74.1849 12.5298 74.8709 13.2219 75.8449 13.2219ZM75.8449 12.7625C75.1711 12.7625 74.6933 12.2541 74.6933 11.5497C74.6933 10.8514 75.1711 10.3429 75.8449 10.3429C76.5126 10.3429 76.9965 10.8514 76.9965 11.5497C76.9965 12.2541 76.5126 12.7625 75.8449 12.7625Z"
      fill="currentColor"
    />
    <path
      d="M78.3747 13.0994H78.8831V11.2924C78.8831 10.7534 79.3302 10.3491 79.8509 10.3491C80.3838 10.3491 80.6962 10.7289 80.6962 11.2495V13.0994H81.2047V11.2495C81.2047 10.4655 80.7024 9.88965 79.9183 9.88965C79.5079 9.88965 79.1648 10.0857 78.9443 10.4287H78.8831V10.006H78.3747V13.0994Z"
      fill="currentColor"
    />
    <path
      d="M84.9243 13.2158C85.0774 13.2158 85.2796 13.1852 85.4266 13.1362V12.7258C85.3102 12.7625 85.151 12.787 85.0591 12.787C84.765 12.787 84.5813 12.5788 84.5813 12.2847V10.4103H85.3776V10.006H84.5813L84.5874 9.00758H84.1892L84.0729 10.006H83.5706V10.4103H84.0729V12.3031C84.0729 12.8483 84.4036 13.2158 84.9243 13.2158Z"
      fill="currentColor"
    />
    <path
      d="M86.2904 13.0994H86.7988V11.2924C86.7988 10.7411 87.2459 10.3429 87.7666 10.3429C88.2995 10.3429 88.6119 10.7166 88.6119 11.2434V13.0994H89.1204V11.2434C89.1204 10.4532 88.6181 9.88353 87.834 9.88353C87.4236 9.88353 87.0806 10.0734 86.86 10.3981H86.7988V8.59717H86.2904V13.0994Z"
      fill="currentColor"
    />
    <path
      d="M91.6063 13.2219C92.2923 13.2219 92.8498 12.9034 93.1009 12.3766L92.6782 12.1622C92.4822 12.5298 92.0779 12.7625 91.6185 12.7625C90.9876 12.7625 90.5343 12.346 90.4608 11.7212H93.1989C93.205 11.6538 93.205 11.5803 93.205 11.519C93.205 10.5696 92.5251 9.88353 91.5818 9.88353C90.6262 9.88353 89.9401 10.5696 89.9401 11.5129C89.9401 12.5053 90.6384 13.2219 91.6063 13.2219ZM90.4669 11.274C90.5527 10.7166 90.9876 10.3429 91.5573 10.3429C92.1453 10.3429 92.5802 10.7166 92.6721 11.274H90.4669Z"
      fill="currentColor"
    />
    <path
      d="M45.9841 26.5756C48.5738 26.5756 50.3153 24.6192 50.1457 21.9051H45.1472V22.8211L49.1053 22.8324C49.06 24.4383 47.703 25.6709 45.9841 25.6709C44.0842 25.6709 42.7159 24.246 42.7159 22.3009C42.7159 20.3332 44.0729 18.9422 45.9841 18.9422C47.2167 18.9422 48.3363 19.666 48.6755 20.6612L49.6142 20.3445C49.1731 19.0101 47.6578 18.0376 45.9841 18.0376C43.4849 18.0376 41.6868 19.8243 41.6868 22.3009C41.6868 24.7775 43.4849 26.5756 45.9841 26.5756Z"
      fill="currentColor"
    />
    <path
      d="M54.4531 26.5191C56.2399 26.5191 57.5177 25.2412 57.5177 23.4318C57.5177 21.6337 56.2399 20.3558 54.4531 20.3558C52.655 20.3558 51.3885 21.6337 51.3885 23.4318C51.3885 25.2412 52.655 26.5191 54.4531 26.5191ZM54.4531 25.6709C53.2091 25.6709 52.3271 24.7323 52.3271 23.4318C52.3271 22.1426 53.2091 21.204 54.4531 21.204C55.6857 21.204 56.5791 22.1426 56.5791 23.4318C56.5791 24.7323 55.6857 25.6709 54.4531 25.6709Z"
      fill="currentColor"
    />
    <path
      d="M61.803 26.5191C63.5898 26.5191 64.8676 25.2412 64.8676 23.4318C64.8676 21.6337 63.5898 20.3558 61.803 20.3558C60.0049 20.3558 58.7383 21.6337 58.7383 23.4318C58.7383 25.2412 60.0049 26.5191 61.803 26.5191ZM61.803 25.6709C60.559 25.6709 59.677 24.7323 59.677 23.4318C59.677 22.1426 60.559 21.204 61.803 21.204C63.0356 21.204 63.929 22.1426 63.929 23.4318C63.929 24.7323 63.0356 25.6709 61.803 25.6709Z"
      fill="currentColor"
    />
    <path
      d="M69.1529 29.12C70.9962 29.12 72.1949 27.9779 72.1949 26.1911V20.582H71.2676V21.3962H71.1545C70.6683 20.7629 69.9784 20.3671 69.0624 20.3671C67.3435 20.3671 66.0996 21.6676 66.0996 23.4318C66.0996 25.1846 67.3435 26.4399 69.0624 26.4399C69.9558 26.4399 70.6456 26.0554 71.1432 25.4221H71.2563V26.1911C71.2563 27.469 70.4421 28.2719 69.1981 28.2719C68.1804 28.2719 67.4566 27.7517 67.1513 26.8696L66.2126 27.2202C66.5971 28.4076 67.6828 29.12 69.1529 29.12ZM69.1642 25.6144C67.9316 25.6144 67.0382 24.687 67.0382 23.4318C67.0382 22.1426 67.9316 21.204 69.1642 21.204C70.3855 21.204 71.2902 22.1426 71.2902 23.4318C71.2902 24.687 70.3969 25.6144 69.1642 25.6144Z"
      fill="currentColor"
    />
    <path
      d="M74.0196 26.2929H74.9582V17.981H74.0196V26.2929Z"
      fill="currentColor"
    />
    <path
      d="M79.5683 26.5191C80.8349 26.5191 81.864 25.931 82.3276 24.9585L81.5473 24.5627C81.1854 25.2412 80.4391 25.6709 79.5909 25.6709C78.4261 25.6709 77.5893 24.9019 77.4536 23.7484H82.5086C82.5199 23.624 82.5199 23.4883 82.5199 23.3752C82.5199 21.6224 81.2646 20.3558 79.5231 20.3558C77.7589 20.3558 76.4923 21.6224 76.4923 23.3639C76.4923 25.1959 77.7815 26.5191 79.5683 26.5191ZM77.4649 22.9229C77.6232 21.8938 78.4261 21.204 79.4778 21.204C80.5635 21.204 81.3664 21.8938 81.536 22.9229H77.4649Z"
      fill="currentColor"
    />
    <path
      d="M87.1839 26.2929H88.1904V23.2056H90.3617C92.058 23.2056 93.2228 22.267 93.2228 20.7629C93.2341 19.2363 92.1032 18.3203 90.3617 18.3203H87.1839V26.2929ZM88.1904 22.2896V19.225H90.3617C91.5151 19.225 92.205 19.8243 92.205 20.7629C92.205 21.6903 91.5151 22.2896 90.3617 22.2896H88.1904Z"
      fill="currentColor"
    />
    <path
      d="M94.6616 26.2929H95.6002V17.981H94.6616V26.2929Z"
      fill="currentColor"
    />
    <path
      d="M99.0229 26.4738C99.9389 26.4738 100.606 26.1119 101.013 25.456H101.115V26.2929H102.054V22.5045C102.054 21.204 101.115 20.3671 99.6336 20.3671C98.1974 20.3671 97.2587 21.1361 97.2587 22.3462H98.2087C98.1974 21.6337 98.7628 21.2153 99.6223 21.2153C100.561 21.2153 101.115 21.7129 101.115 22.4819V22.708L99.5318 22.9003C97.8355 23.0925 96.976 23.8389 96.976 24.8454C96.976 25.8292 97.7902 26.4738 99.0229 26.4738ZM99.1586 25.6935C98.3896 25.6935 97.9146 25.3656 97.9146 24.8228C97.9146 24.2912 98.367 23.8389 99.5318 23.6919L101.115 23.5109V24.0198C101.115 24.9811 100.323 25.6935 99.1586 25.6935Z"
      fill="currentColor"
    />
    <path
      d="M104.316 28.826C105.549 28.826 106.001 27.6499 106.51 26.3834L108.772 20.582H107.766L106.092 25.0489H105.979L104.022 20.582H103.038L105.583 26.2816C105.244 27.0845 105.018 27.9892 104.169 27.9892C103.955 27.9892 103.672 27.9213 103.412 27.8196V28.6451C103.672 28.7582 104.034 28.826 104.316 28.826Z"
      fill="currentColor"
    />
    <rect
      x="1.15772"
      y="0.586917"
      width="120.336"
      height="36.5435"
      rx="4.24075"
      stroke="currentColor"
      stroke-width="0.942389"
    />
    <defs>
      <clipPath id="clip0">
        <rect
          width="16.963"
          height="17.9054"
          fill="currentColor"
          transform="translate(13.8799 9.90601)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    width: { type: [String, Boolean], default: false },
    height: { type: [String, Boolean], default: false },
  },
};
</script>
